import { memo, Fragment, createElement, useRef } from 'react'
import { Global, css } from '@emotion/react'
import { Modal } from '@leroy-merlin-br/backyard-react-ui'

import * as ModalComponent from 'lmcv/components/Modal'
import * as ModalDynamic from 'lmcv/containers/ModalDynamic'
import {
  useModal,
  useCloseModal
} from 'lmcv/hooks/modal/use-modal'

const globalStyles = css`
  .ReactModal__Html--open {
    height: 100%;
    overflow-y: hidden;
    -webkit-overflow-scrolling: auto;
  }
`

function ModalContainer (props) {
  const { modal } = useModal()
  const { handleOnClose } = useCloseModal()

  const modalRef = useRef()

  if (!modal.type) {
    return null
  }

  const element = el => {
    return createElement(el[modal.type], {
      ...modal.componentProps,
      ...props
    })
  }

  const getModal = () =>
    modal.dynamic ? element(ModalDynamic) : element(ModalComponent)

  return (
    <Fragment>
      {modal.open && <Global styles={globalStyles} />}
      <Modal
        appElement="body"
        size="giga"
        isOpen={modal.open}
        onClose={handleOnClose}
        hiddenClose={modal.hiddenClose}
        shouldCloseOnOverlayClick={false}
        ref={modalRef}
      >
        {getModal()}
      </Modal>
    </Fragment>
  )
}

export default memo(ModalContainer)
